import { v4 as uuidv4 } from "uuid"
import { KizExchangeGridByLot } from "./KixExchangeGridByLot"
import KizExchangeGridPluginSettings from "./KizExchangeGridPluginSettings"

export const KizExchangeTabByLot = (idGlobal: string, goodsCode: string, barcode?: string): ITab => { 
    
    return {
        id: uuidv4(),
        title: `Журнал КИЗ - ${goodsCode}`,
        view: {
            content: KizExchangeGridPluginSettings ? <KizExchangeGridByLot idGlobal={idGlobal} goodsCode={goodsCode} barcode={barcode} /> : <p>Справочник не настроен</p>,
        },
    };
};

export default KizExchangeTabByLot;
